export default "__VITE_ASSET__DKQQ00uc__"